/* eslint-disable @typescript-eslint/no-explicit-any */
import "react-toastify/dist/ReactToastify.css";
import { buildUrl } from "../../utils/bindUrl";
import {
  ICustomersSuppliers,
  IResponseListCustomersSuppliers,
  IResponseShowCustomerSupplier,
} from "../../interfaces/customersSuppliers";
import qs from "qs";
import { api } from "../api/httpClient";
import { IListParams } from "@/interfaces/serviceInterface";

const BASE = "/financial/customers_suppliers";

// serializer padrão (arrays em brackets, ignora null/undefined)
const serialize = (p: any) =>
  qs.stringify(p, { arrayFormat: "brackets", skipNulls: true, encode: true });

export async function listCustomersSuppliers({
  filter,
  includes,
  page,
  limit,
  select,
}: IListParams) {
  const { data } = await api.get<IResponseListCustomersSuppliers>(BASE, {
    params: { filter, includes, page, limit, select },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function showCustomerSupplier({
  id,
  includes,
}: {
  id: string | number;
  includes?: string[];
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.get<IResponseShowCustomerSupplier>(url, {
    params: { includes },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function createCustomerSupplier({
  customerSupplier,
}: {
  customerSupplier: ICustomersSuppliers;
}) {
  const { data } = await api.post<IResponseShowCustomerSupplier>(BASE, {
    customerSupplier,
  });
  return data;
}

export async function updateCustomerSupplier({
  id,
  customerSupplier,
}: {
  id: string | number;
  customerSupplier: ICustomersSuppliers;
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.put<IResponseShowCustomerSupplier>(url, {
    customerSupplier,
  });
  return data;
}
